import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useStore } from '../../store/useStore';
import LoadingScreen from '../common/LoadingScreen';
import Layout from '../layout/Layout';

const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = useStore();

  if (isLoading) {
    return <LoadingScreen message="Authenticating..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PrivateRoute;